class MakesList extends HTMLElement {
  constructor() {
    super();
    this.makesList = this.querySelector('.js-makes-list');
    this.init();
  }

  init() {
    if (!this.makesList) return;
    
    // Đợi YMM_DATA load xong
    this.waitForYMMData(() => {
      this.renderMakes();
    });
  }

  waitForYMMData(callback, maxAttempts = 100, attempt = 0) {
    if (typeof YMM_DATA !== 'undefined' && YMM_DATA && Object.keys(YMM_DATA).length > 0) {
      callback();
      return;
    }

    if (attempt >= maxAttempts) {
      console.error('[MakesList] YMM_DATA not available after max attempts');
      callback(); // Vẫn gọi callback để không block UI
      return;
    }

    setTimeout(() => {
      this.waitForYMMData(callback, maxAttempts, attempt + 1);
    }, 100);
  }

  slugify(str) {
    if (!str) return '';
    return str
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  }

  capitalize(str) {
    if (!str) return '';
    return str
      .toString()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  getAllMakes() {
    if (typeof YMM_DATA === 'undefined' || !YMM_DATA || Object.keys(YMM_DATA).length === 0) {
      return [];
    }

    const makesSet = new Set();

    // Loop qua tất cả years trong YMM_DATA
    Object.keys(YMM_DATA).forEach((year) => {
      const makes = YMM_DATA[year];
      if (makes) {
        // Lấy tất cả make keys
        Object.keys(makes).forEach((make) => {
          makesSet.add(make);
        });
      }
    });

    // Convert Set to Array và sort alphabetically
    const makesArray = Array.from(makesSet);
    makesArray.sort((a, b) => {
      const nameA = this.capitalize(a).toLowerCase();
      const nameB = this.capitalize(b).toLowerCase();
      return nameA.localeCompare(nameB);
    });

    return makesArray;
  }

  renderMakes() {
    if (!this.makesList) return;

    const makes = this.getAllMakes();
    
    if (makes.length === 0) {
      this.makesList.innerHTML = '<li class="makes-list__item">No makes available</li>';
      return;
    }

    // Clear existing content
    this.makesList.innerHTML = '';

    // Render all makes
    makes.forEach((make) => {
      const makeSlug = this.slugify(make);
      const makeUrl = `/${makeSlug}`;
      
      const li = document.createElement('li');
      li.className = 'makes-list__item';
      
      const link = document.createElement('a');
      link.href = makeUrl;
      link.className = 'makes-list__link';
      link.textContent = this.capitalize(make);
      
      li.appendChild(link);
      this.makesList.appendChild(li);
    });
  }
}

customElements.define('makes-list', MakesList);

